export const enContent = {
    "Your ifc Points:": "Your ifc Points:",
    "ifc Points": "ifc Points",
    "Out of stock": "Out of stock ",
    "Low in stock": "Low in stock",
    "Redemption period": "Redemption period",
    "Valid until": "Valid until",
    "Required ifc Points: ": "Required ifc Points: ",
    "Redeem": "Redeem",
    "Confirm to redeem with x,xxx ifc Points? ": "Confirm to redeem with <br>{points} ifc Points? ",
    "Quantity": "Quantity: ",
    "pc(s)": "pc(s)",
    "Click \"Confirm\" to proceed.": "Click \"Confirm\" to proceed.",
    "The redemption cannot be cancelled or changed after confirmation.": "The redemption cannot be cancelled or changed after confirmation.",
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Done": "Done",
    "Check Rewards": "Check Rewards",
    "Check Gift Voucher": "Check Voucher",
    "You have successfully redeemed:": "You have successfully redeemed:",
    "Sorry, something went wrong.": "Sorry, something went wrong.",
    "Please check your network settings and try again.": "Please check your network settings and try again.",
    "OK": "OK"
}